import ApplicationController from "./application_controller";

/*
 * Absage-Pool im Bewerber-Kopf (Niederlassungsleiter)
 * ===================================================
 *
 * Wird im Pool-Dropdown ein Absage-Pool gewählt, wird NICHT der ganze Bewerber
 * abgesagt (Auto-Submit). Stattdessen startet die Absage einer einzelnen
 * Bewerbung über deren "Absagen"-Knopf (data-decline-trigger, siehe
 * decline_trigger_data). Bei mehreren offenen Bewerbungen wird gefragt, welche.
 *
 * Usage: data-action="change->decline-pool-guard#check change->auto-submit#submit"
 * (Reihenfolge wichtig – check stoppt den Auto-Submit.)
 */
export default class extends ApplicationController {
  static targets = ["select"]
  static values = {
    poolIds: Array,
    title: String,
    hint: String,
    action: String,
    cancel: String
  }

  connect() {
    this.previous = this.currentValue()
  }

  disconnect() {
    this.closeChooser()
  }

  check(event) {
    const value = this.currentValue()
    if (!this.poolIdsValue.includes(String(value))) {
      this.previous = value
      return
    }

    const triggers = Array.from(document.querySelectorAll("[data-decline-trigger]"))
    // Keine offene Bewerbung mit Absage-Knopf: bisheriges Verhalten beibehalten.
    if (triggers.length === 0) {
      this.previous = value
      return
    }

    event.stopImmediatePropagation()
    this.restore()

    if (triggers.length === 1) {
      this.fire(triggers[0])
    } else {
      this.openChooser(triggers)
    }
  }

  currentValue() {
    return this.hasSelectTarget ? this.selectTarget.value : ""
  }

  restore() {
    const tomselect = this.selectTarget.tomselect
    if (tomselect) {
      tomselect.setValue(this.previous || "", true)
    } else {
      this.selectTarget.value = this.previous || ""
    }
  }

  fire(trigger) {
    trigger.scrollIntoView({ block: "center" })
    trigger.click()
  }

  openChooser(triggers) {
    this.closeChooser()

    const overlay = this.element_("div", "fixed inset-0 z-50 flex items-center justify-center bg-gray-500 bg-opacity-75 p-4")
    overlay.setAttribute("role", "dialog")
    overlay.setAttribute("aria-modal", "true")

    const box = this.element_("div", "w-full max-w-lg rounded-lg bg-white p-6 shadow-xl")
    const title = this.element_("h3", "text-lg font-medium leading-6 text-gray-900", this.titleValue)
    title.id = "decline-pool-guard-title"
    overlay.setAttribute("aria-labelledby", title.id)
    box.appendChild(title)
    box.appendChild(this.element_("p", "mt-2 text-sm text-gray-500", this.hintValue))

    const list = this.element_("div", "mt-4 space-y-2")
    triggers.forEach((trigger) => {
      const option = this.element_("button", "w-full rounded-md border border-gray-300 bg-white px-4 py-3 text-left text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500")
      option.type = "button"
      option.appendChild(this.element_("span", "block", trigger.dataset.declineLabel || ""))
      option.appendChild(this.element_("span", "mt-1 block text-xs text-red-600", this.actionValue))
      option.addEventListener("click", () => {
        this.closeChooser()
        this.fire(trigger)
      })
      list.appendChild(option)
    })
    box.appendChild(list)

    const footer = this.element_("div", "mt-5 flex justify-end")
    const cancel = this.element_("button", "rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50", this.cancelValue)
    cancel.type = "button"
    cancel.addEventListener("click", () => this.closeChooser())
    footer.appendChild(cancel)
    box.appendChild(footer)

    overlay.appendChild(box)
    overlay.addEventListener("click", (event) => {
      if (event.target === overlay) this.closeChooser()
    })
    this.keyHandler = (event) => {
      if (event.key === "Escape") this.closeChooser()
    }
    document.addEventListener("keydown", this.keyHandler)

    document.body.appendChild(overlay)
    this.overlay = overlay
    const first = list.querySelector("button")
    if (first) first.focus()
  }

  closeChooser() {
    if (this.overlay) {
      this.overlay.remove()
      this.overlay = null
    }
    if (this.keyHandler) {
      document.removeEventListener("keydown", this.keyHandler)
      this.keyHandler = null
    }
  }

  // textContent statt innerHTML: Stellentitel kommen aus Nutzereingaben.
  element_(tag, className, text) {
    const el = document.createElement(tag)
    el.className = className
    if (text !== undefined) el.textContent = text
    return el
  }
}
